import React, { useEffect, useState } from 'react';
import { transactionHistory } from '../../redux/reducers/AppoinmentSlice';
import { useDispatch } from 'react-redux';

const TransactionHistory = () => {
  const dispatch = useDispatch();
  const [transactionHistoryData, setTransactionHistoryData] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchTransactionHistory = async () => {
      try {
        const payload = { page: currentPage };
        const responseTransactionHistory = await dispatch(transactionHistory(payload));
        setTransactionHistoryData(responseTransactionHistory.payload.data);
        setTotalPages(responseTransactionHistory.payload.total_pages);
      } catch (error) {
        // Error fetching data
      }
    };
    fetchTransactionHistory();
  }, [dispatch, currentPage]);

  // Filter transactions based on search term
  useEffect(() => {
    if (!transactionHistoryData || !Array.isArray(transactionHistoryData)) {
      setFilteredTransactions([]);
      return;
    }
    
    const filteredData = transactionHistoryData.filter((transaction) =>
      transaction.appointment_id.toString().includes(searchTerm) ||
      transaction.date.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (transaction.payment_token && transaction.payment_token.toLowerCase().includes(searchTerm.toLowerCase())) ||
      transaction.amount.toString().includes(searchTerm) ||
      transaction.payment_type.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredTransactions(filteredData);
  }, [searchTerm, transactionHistoryData]);

  return (
    <>
      <div className="appointment_history">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
  <h5 style={{ margin: 0 }}>Transaction History</h5>
  <input
    type="text"
    className="search-bar"
    placeholder="Search"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    style={{
      width: "250px",
      padding: "5px",
      borderRadius: "5px",
      border: "1px solid #ccc"
    }}
  />
</div>


        <div className="table-responsive">
          <table className="table">
            <tbody className="tf_dashboard__listing_body">
              <tr>
                <th className="th_sn"><p>#</p></th>
                <th className="th_name"><p>Appointment ID</p></th>
                <th className="th_date"><p>Date</p></th>
                <th className="transection"><p>Transaction ID</p></th>
                <th className="th_amount"><p>Amount</p></th>
                <th className="payment_method"><p>Payment Method</p></th>
              </tr>

              {filteredTransactions.map((transaction, index) => (
                <tr key={index} className="tabile_row transection_history">
                  <td className="th_sn"><p>{index + 1}</p></td>
                  <td className="th_name"><p>{transaction.appointment_id}</p></td>
                  <td className="th_date"><p>{transaction.date}</p></td>
                  <td className="transection"><p>{transaction.payment_token || '-'}</p></td>
                  <td className="th_amount"><p>Rs. {transaction.amount}</p></td>
                  <td className="payment_method"><p>{transaction.payment_type}</p></td>
                </tr>       
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="row mt_60">
          <div className="col-12">
            <div id="pagination">
              <nav aria-label="...">
                <ul className="pagination justify-content-center">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                      <i className="fas fa-arrow-left"></i>
                    </button>
                  </li>
                  {Array.from({ length: totalPages }, (_, index) => index + 1).map((page) => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(page)}>
                        {page}
                      </button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                      <i className="fas fa-arrow-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionHistory;
